interface SplitDividerProps {
  /** Axis the divider separates — "vertical" means it runs top-to-bottom
   *  and resizes horizontally (left/right panes); "horizontal" runs
   *  left-to-right and resizes vertically. */
  direction?: 'vertical' | 'horizontal';
  onDragStart(e: React.MouseEvent): void;
  /** Double-click handler — typical use is to reset to default size. */
  onDoubleClick?(): void;
  /** Tooltip text shown on hover. */
  title?: string;
}

/**
 * Thin draggable divider strip. Place inside the CSS grid cell that
 * sits between two resizable panes. Supply the grid's
 * `grid-template-columns` (or rows) such that this divider occupies a
 * fixed-size track (e.g. `4px`) between the two flexible tracks.
 */
export function SplitDivider({
  direction = 'vertical',
  onDragStart,
  onDoubleClick,
  title,
}: SplitDividerProps): JSX.Element {
  return (
    <div
      className={`split-divider split-divider--${direction}`}
      onMouseDown={onDragStart}
      {...(onDoubleClick ? { onDoubleClick } : {})}
      role="separator"
      aria-orientation={direction === 'vertical' ? 'vertical' : 'horizontal'}
      title={title ?? 'Drag to resize · double-click to reset'}
    >
      <div className="split-divider-grip" />
    </div>
  );
}
